export const REDUX_LEVELS = 'REDUX_LEVELS'
